import { render, staticRenderFns } from "./ConversationPage.vue?vue&type=template&id=83b19000&scoped=true"
import script from "./ConversationPage.vue?vue&type=script&lang=js"
export * from "./ConversationPage.vue?vue&type=script&lang=js"
import style0 from "./ConversationPage.vue?vue&type=style&index=0&id=83b19000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b19000",
  null
  
)

export default component.exports